export default __webpack_public_path__ + "media/d61b88da5b4559925abf2c5e23851bc31a6d0d530e02a9d8d6b34f2972c45e31.svg";